import {fetch as fetchRaw} from '@lib/fetch'
import {constants} from '../services'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([constants.url, url], ...args)

export function getCountriesList(queryParams) {
  return fetch(`/v1/countries?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  })
}

export function createCountry(body) {
  return fetch(`/v1/countries`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function getCountryByCountryCode(countryCode) {
  return fetch(`/v1/countries/${countryCode}`, {
    method: 'GET',
  })
}

export function updateCountry(countryCode, body) {
  return fetch(`/v1/countries/${countryCode}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  })
}

export function deleteCountry(countryCode) {
  return fetch(`/v1/countries/${countryCode}`, {
    method: 'DELETE',
  })
}
